/* eslint-disable max-len */
/* eslint-disable react/prop-types */
import React from 'react';
import { useSelector } from 'react-redux';
import moment from 'moment';
import {
  Calendar,
  momentLocalizer,
  Views,
} from 'react-big-calendar';
import PropTypes from 'prop-types';
import { useMediaQuery } from '@mui/material';
import theme from '../../../../utils/theme';
import { eventStyleHandler } from '../../../../utils/scheduleHelper';
import CustomToolbar from './components/Toolbar';
import Event from './components/Event';
import EventAgenda from './components/EventAgenda';

const localizer = momentLocalizer(moment);

const CalendarComponent = ({
  handleEventClick,
  setSelectedSlot,
  setStartDate,
  setEndDate,
  setOpenQuickSelectMenu,
  defaultCalendarView,
}) => {
  const lgDown = useMediaQuery(theme.breakpoints.down('md'));

  // React State
  const [calendarView, setCalendarView] = React.useState(Views.WEEK);

  const selectedBarn = useSelector((state) => state.barn.selectedBarn);
  const events = useSelector((state) => state.board.events);

  const horseTagTypeId = (selectedBarn.barnMetadata && selectedBarn.barnMetadata.horseTagTypeId) || 0;
  // const isLoading = isFetchingBoard;

  React.useEffect(() => {
    if (defaultCalendarView && defaultCalendarView === 'month') {
      setCalendarView(Views.month)
      setStartDate(moment().startOf('month').toDate());
      setEndDate(moment().endOf('month').toDate());
    } else {
      setCalendarView(lgDown
        ? Views.DAY
        : Views.WEEK);
    }
  }, [lgDown])

  const handleRangeChange = (e) => {
    if (e.start && e.end) {
      setStartDate(moment(e.start).toDate());
      setEndDate(moment(e.end).toDate());
    } else if (e.length === 1) {
      setStartDate(moment(e[0]).startOf('day').toDate());
      setEndDate(moment(e[0]).endOf('day').toDate());
    } else if (e.length === 7) {
      setStartDate(moment(e[0]).startOf('day').toDate());
      setEndDate(moment(e[6]).endOf('day').toDate());
    }
  };

  const { components } = React.useMemo(
    () => ({
      components: {
        agenda: { event: EventAgenda },
        event: Event,
        toolbar: CustomToolbar,
      },
    }),
    [],
  );

  return (
    <Calendar
      components={components}
      localizer={localizer}
      view={calendarView}
      onView={(newView) => setCalendarView(newView)}
      eventPropGetter={eventStyleHandler}
      step={15}
      onRangeChange={handleRangeChange}
      onKeyPressEvent={handleEventClick}
      onSelectEvent={handleEventClick}
      onDoubleClickEvent={handleEventClick}
      selectable
      onSelectSlot={(slot) => { setOpenQuickSelectMenu(true); setSelectedSlot(slot); }}
      events={events.map((e) => ({
        ...e,
        view: calendarView,
        horseTags: e.resource.tags.filter((et) => et.tagType.id === horseTagTypeId),
      }))}
      startAccessor="start"
      endAccessor="end"
      style={{ height: 1000 }}
      scrollToTime={
        moment().add(-2, 'hours').toDate()
    }
      defaultDate={moment(new Date()).startOf('day').toDate()}
      // min={moment().startOf('day').add(6, 'hours').toDate()} // On DST weeks this breaks the side time gutter on the calendar https://github.com/jquense/react-big-calendar/issues/1098
      // max={moment().startOf('day').add(22, 'hours').toDate()}
    />
  );
};

CalendarComponent.propTypes = {
  handleEventClick: PropTypes.func.isRequired,
  setSelectedSlot: PropTypes.func.isRequired,
  setStartDate: PropTypes.func.isRequired,
  setEndDate: PropTypes.func.isRequired,
  setOpenQuickSelectMenu: PropTypes.func.isRequired,
  defaultCalendarView: PropTypes.string,
};

CalendarComponent.defaultProps = { defaultCalendarView: null };

export default (CalendarComponent);

